import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-issue-web-confirmation',
    templateUrl: './issue-web-confirmation.component.html',
    styleUrls: ['./issue-web-confirmation.component.scss']
})
export class IssueWebConfirmationComponent implements OnInit {

    constructor(private route: ActivatedRoute, public router: Router) { }
    Id: any;
    ngOnInit() {

        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                this.Id = id;
                let self = this;
                setTimeout(function() {
                    self.router.navigate([`/issues/${id}/create`], { relativeTo: this.route });

                }, 5000);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/IssueWeb/public/issue-web-confirmation/issue-web-confirmation.component.ts